<template>
    <div class="sale_banner_card" @click="getMerchandiseProducts(bannerSale.id)">
      <div class="img_wrapper spinner_wrapper" v-lazyload v-if="bannerSale.bannerUrl">
        <ImageSpinner class="image_spinner" />
        <img :data-url="bannerSale.bannerUrl" alt="banner" />
      </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ImageSpinner from "../Common/ImageSpinner";
import constant from "../../utils/constant";
export default {
  name: "ShopNow",
  props: {
    bannerSale: {
      type: Object
    }
  },
  components: {
    ImageSpinner
  },
  data() {
    return {
    };
  },
  methods: {
    getMerchandiseProducts(merchandiseId) {
      if (this.$route.path == "/") {
        clevertap.event.push("merchandising_banner_click", {
          merchandiseId: merchandiseId
        });
        this.$router.onError(err => {
          if (/loading chunk \d* failed./i.test(err.message)) {
            window.location.reload();
          }
        });
        this.$router.push("/merchandise-product-by-id/" + merchandiseId);
      } else {
        return;
      }
    }
  }
};
</script>